import { render, staticRenderFns } from "./goodsRecordManage.vue?vue&type=template&id=27d841e2&"
import script from "./goodsRecordManage.vue?vue&type=script&lang=js&"
export * from "./goodsRecordManage.vue?vue&type=script&lang=js&"
import style0 from "./goodsRecordManage.vue?vue&type=style&index=0&id=27d841e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports